module.exports = __webpack_public_path__ + "static/media/rewardsnew.1934e044.svg";